module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_ANTI-BACTERIAL PU_deskstop.c37ff084.jpg";